import React from 'react'
import TypedBody from './TypedBody'
import image from '../Image.jpeg'
import Button from '@mui/material/Button';
import ContactMeModal from './ContactMeModal'



export default function Home() {
  return (
    <div className='home' >

           

            <div className='owner' >
                <p className='greeting'>Hi There , I am </p>
                <p className='name' >Sahil Rohera</p> 

                 <TypedBody/>
                 <br />
                 <br />
                 <br />
                 <br />

              <div style={{display : 'flex'}} >
                    {/* <Button variant="outlined" style={{color : 'rgb(115, 32, 194)' , border : '1px solid rgb(115, 32, 194)' , marginRight : '20px'}}>Download CV </Button> */}
                    
                                    
                    <ContactMeModal  />

              </div>
               

            </div>


          
            <img src={image} alt="image" className='bitmoji' />
           



    </div>
  )
}
